export const institutionalFr = {
  'institutional.title': 'Conseil Institutionnel',
  'institutional.subtitle': 'Nous structurons et pilotons vos projets d\'État de bout en bout',
  'institutional.forWhom.title': 'Pour qui',
  'institutional.forWhom.description': 'Ministères, agences nationales, bailleurs internationaux (AFD, Banque Mondiale, BAD)',
  'institutional.whatWeDo.title': 'Ce que nous faisons',
  'institutional.whatWeDo.item1': 'Digitalisation de registres nationaux',
  'institutional.whatWeDo.item2': 'Gouvernance et systèmes d\'information souverains',
  'institutional.whatWeDo.item3': 'Gestion de projets structurants EPC+F / BOT',
  'institutional.whatWeDo.item4': 'Cloud souverain et protection des données',
  'institutional.howWeWork.title': 'Comment nous travaillons',
  'institutional.howWeWork.description': 'Nous intervenons en trois phases : diagnostic stratégique, conception technique, déploiement et transfert de compétences.',
  'institutional.howWeWork.phase1': 'Diagnostic stratégique',
  'institutional.howWeWork.phase2': 'Conception technique',
  'institutional.howWeWork.phase3': 'Déploiement et transfert',
  'institutional.cta': 'Discuter de votre projet institutionnel'
};

export default institutionalFr;